//src/common/header/HeaderOne.js
import React, { useState, useEffect } from "react";
import Logo from "../../elements/logo/Logo";
import Nav from "../../common/header/Nav";
import OffcanvasMenu from "./OffcanvasMenu";
import StickyHeader from "./StickyHeader";
import MobileMenu from "./MobileMenu";
import { FaFacebookF, FaInstagram, FaLinkedin } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { Home, LogIn, Monitor, MonitorCog, Search } from "lucide-react";
import { CgProfile } from "react-icons/cg";
import SearchPopup from "../../elements/search-popup/SearchPopup";

const HeaderOne = () => {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const OffcanvasHandleClose = () => setShowOffcanvas(false);
  const OffcanvasHandleShow = () => setShowOffcanvas(true);

  const sticky = StickyHeader(100);

  const MobileMenuHandler = () => {
    const mobileMenuPopup = document.querySelector(".mobilemenu-popup");
    const body = document.querySelector("body");
  
    if (mobileMenuPopup && body) {
      mobileMenuPopup.classList.toggle("show");
      body.classList.toggle("mobilemenu-show");
    }
  
    // Update how submenu toggles are handled
    const menuItemsWithChildren = document.querySelectorAll(
      ".mobilemenu-popup .menu-item-has-children"
    );
  
    menuItemsWithChildren.forEach((item) => {
      // Find dropdown toggles instead of links
      const toggleSpan = item.querySelector(".dropdown-toggle");
      const submenu = item.querySelector(".axil-submenu");
  
      if (toggleSpan && submenu) {
        // Remove any existing listeners first to avoid duplicates
        toggleSpan.removeEventListener("click", toggleSubmenuHandler);
        // Add new listener
        toggleSpan.addEventListener("click", toggleSubmenuHandler);
      }
    });
  };
  
  // Separate function for toggling submenus
  const toggleSubmenuHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const submenu = e.currentTarget.closest('.menu-item-has-children').querySelector('.axil-submenu');
    if (submenu) {
      submenu.classList.toggle("active");
    }
  };

  useEffect(() => {
    // Cleanup event listeners if needed
    return () => {
      const menuItemsWithChildren = document.querySelectorAll(
        ".mobilemenu-popup .menu-item-has-children"
      );
      menuItemsWithChildren.forEach((item) => {
        const toggleLink = item.querySelector("a");
        if (toggleLink) {
          toggleLink.removeEventListener("click", () => {});
        }
      });
    };
  }, []);

  const location = useLocation();

  const handleHomeClick = (e) => {
    if (location.pathname === "/") {
      e.preventDefault();
      // Optional: Scroll smoothly to top if you want that behavior
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  // Check if the current path is the homepage
  const isHomePage = location.pathname === "/";
  return (
    <>
      <header className="header axil-header header-style-1">
        <div className={`axil-mainmenu ${sticky ? "axil-sticky" : ""}`}>
          <div className="container">
            <div className="header-navbar">
              <div className="header-logo" onClick={handleHomeClick}>
                <Logo
                  limage="/images/ucwf-logo-header.png"
                  dimage="/images/logo-3.svg"
                  simage="/images/ucwf-logo-header.png"
                />
              </div>
              <div className="header-main-nav">
                <div className="d-none d-lg-block">
                  <div className="header-social-link">
                    <div className="header-action">
                      <ul className="list-unstyled">
                        <li className="menu-item-has-children">
                          <Link
                            to="/"
                            onClick={handleHomeClick}
                            title="Home"
                            style={{
                              color: !isHomePage
                                ? "#562b7a"
                                : sticky
                                ? "#562b7a"
                                : "",
                              fontWeight: 500,
                              fontSize: "16px",
                              paddingTop: "10px",
                            }}
                          >
                            {/* Home */}
                            <Home size={20} />
                            {/* <FaAngleDown /> */}
                          </Link>
                        </li>
                        <li className="menu-item-has-children">
                          <a
                            href="https://ucwf.erpradius.com"
                            title="Software"
                            style={{
                              color: !isHomePage
                                ? "#562b7a"
                                : sticky
                                ? "#562b7a"
                                : "",
                              fontWeight: 500,
                              fontSize: "16px",
                              paddingTop: "10px",
                            }}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {/* <Monitor size={20} /> */}
                            {/* <MonitorCog size={20} /> */}
                            {/* <LogIn size={20} /> */}
                            <CgProfile size={20} />
                          </a>
                        </li>

                        {/* // In your JSX where the search icon is: */}
                        <li className="menu-item-has-children">
                          <button
                            onClick={() => setIsSearchOpen(true)}
                            className="search-trigger"
                            style={{
                              background: "none",
                              border: "none",
                              color: !isHomePage
                                ? "#27272e"
                                : sticky
                                ? "#562b7a"
                                : "",
                              fontWeight: 500,
                              fontSize: "16px",
                              paddingTop: "10px",
                            }}
                          >
                            <Search size={20} />
                          </button>
                        </li>
                        {/* Add this at the bottom of your JSX, before the closing tag */}
                        <SearchPopup
                          isOpen={isSearchOpen}
                          onClose={() => setIsSearchOpen(false)}
                        />

                        <li>
                          <a
                            href="https://www.facebook.com/people/UCWF-Facilities-Management/100063065238562"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: !isHomePage
                                ? "#562b7a"
                                : sticky
                                ? "#562b7a"
                                : "",
                            }}
                          >
                            <FaFacebookF />
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.instagram.com/ucwf_fm"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: !isHomePage
                                ? "#562b7a"
                                : sticky
                                ? "#562b7a"
                                : "",
                            }}
                          >
                            <FaInstagram />
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.linkedin.com/company/ucwf-facilities-management-services"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: !isHomePage
                                ? "#562b7a"
                                : sticky
                                ? "#562b7a"
                                : "",
                            }}
                          >
                            <FaLinkedin />
                          </a>
                        </li>
                        {/* <li><Link to="https://www.instagram.com/"><FaInstagram /></Link></li>
                                            <li><Link to="https://vimeo.com/"><FaVimeoV /></Link></li>
                                            <li><Link to="https://dribbble.com/"><FaDribbble /></Link></li>
                                            <li><Link to="https://www.behance.net/"><FaBehance /></Link></li>
                                            <li><Link to="https://www.tiktok.com/en/"><FaTiktok /></Link></li> */}
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-between">
                  <div className="d-flex justify-content-center w-100">
                    <Nav sticky={sticky} isHomePage={isHomePage} />
                  </div>
                  <div className="header-action">
                    <ul className="list-unstyled">
                      {/* <li className="sidemenu-btn d-lg-block d-none">
                        <button
                          className="btn-wrap"
                          onClick={OffcanvasHandleShow}
                        >
                          <span></span>
                          <span></span>
                          <span></span>
                        </button>
                      </li> */}
                      <li className="mobile-menu-btn sidemenu-btn d-lg-none d-block">
                        <button
                          className="btn-wrap"
                          onClick={MobileMenuHandler}
                        >
                          <span></span>
                          <span></span>
                          <span></span>
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/* <OffcanvasMenu
        offcanvasShow={showOffcanvas}
        offcanvasHide={OffcanvasHandleClose}
      /> */}
      <MobileMenu MobileHandler={MobileMenuHandler} />
    </>
  );
};

export default HeaderOne;
